// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__xIv_s","col":"styles_col__2UH9d"};